import React from "react";

export default function ThreeStepTimeline({ circles = [] }) {
  return (
    <div className="relative w-full h-[180px]">

      {/* Center line relative to circles */}
      <div className="absolute top-[60px] left-0 w-full h-[3px] bg-[#E5E7EB] z-0" />

      {/* 3 Columns */}
      <div className="grid grid-cols-3 w-full relative z-10">
        {circles.map((item, idx) => (
          <div key={idx} className="flex flex-col items-center">

            {/* FIX: Wrapper with fixed height ensures circle is centered at same Y */}
            <div className="h-[120px] flex items-center justify-center">
              <div className="w-[64px] h-[64px] rounded-full border-[4px] border-[#D1D5DB] bg-white flex items-center justify-center">
                <div className="w-[28px] h-[28px] rounded-full bg-[#D1D5DB]" />
              </div>
            </div>

            <p className="mt-2 w-[160px] text-center text-[12px] tracking-wide font-semibold text-[#4B5563] uppercase leading-tight">
              {item.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
